import React from "react";
import MaterialUiClosedPositionsOptions
    from "../closedpositions/MaterialUiClosedPositionsTable";
import {Grid} from "@material-ui/core";
import {ClosedPositionsCsvFile} from "./TradeHistoryDisplays";


const closedPositionHeaders = [
    {
        label: "symbol",
        key: "symbol",
    },
    {
        label: "side",
        key: "side",
    },
    {
        label: "realizedpnl",
        key: "pnl",
    },
    {
        label: " percent_pnl", //sortable: false,
        key: "percent_pnl",
    },
    {
        label: "costbasis",
        key: "cost_basis", //sortable: false,
    },
    {
        label: "quantity",
        key: "quantity",
    },
    {
        label: "entrydate",
        key: "date_acquired",
    },
    {
        label: "closedate", //sortable: false,
        key: "date_exited",
    },
    {
        label: "strategy", sortable: false,
        key: "strategy",
    },
    {
        label: "strategydescription",
        key: "strategyDescription"
    },
    {
        label: "tradePlanTemplate",
        key: "tradePlanTemplate",
    },
    {
        label: "accountId", sortable: false,
        key: "accountId",
    },
    {
        label: "day",
        key: "day",
    }
];
export default function ClosedPositionsHistoryTable({closedPositionsMsg}) {
    let closedPositions = closedPositionsMsg.closedPositions;
    return <>
        <Grid item xs={8}>
            <div style={{textAlign: "left"}}>
            <ClosedPositionsCsvFile closedPositionsMsg={closedPositions}/>
            </div>
            <MaterialUiClosedPositionsOptions values={closedPositions}/>
        </Grid>
    </>;
}